export default "__VITE_ASSET__zkSiQX53__"